import { NatureEnum } from './nature';
import { WorksheetStatusEnum } from './worksheet';

export enum AccountProviderEnum {
    XERO = 'XERO',
}

export enum AccountHistoryEventEnum {
    DRAFT_JOURNAL_CREATE = 'DRAFT_JOURNAL_CREATE',
    JOURNAL_CREATE = 'JOURNAL_CREATE',
    JOURNAL_POSTED = 'JOURNAL_POSTED',
    JOURNAL_REMOVE = 'JOURNAL_REMOVE',
    JOURNAL_UPDATE = 'JOURNAL_UPDATE',
    JOURNAL_VOIDED = 'JOURNAL_VOIDED',
    JOURNAL_ARCHIVED = 'JOURNAL_ARCHIVED',
    BALANCE_CHANGED = 'BALANCE_CHANGED',
    ACCOUNT_ARCHIVED = 'ACCOUNT_ARCHIVED',
    ACCOUNT_UNARCHIVED = 'ACCOUNT_UNARCHIVED',
    ACCOUNT_CREATED = 'ACCOUNT_CREATED',
}

export type Account = {
    id: string;
    providerId: string | null;
    provider: AccountProviderEnum | null;
    workpaperId: string;
    firmId: string;
    code?: string | null;
    description: string;
    class: string;
    type: string;
    workpaperDebitTY?: number | null;
    workpaperCreditTY?: number | null;
    ledgerDebitTY?: number | null;
    ledgerDebitLY?: number | null;
    ledgerCreditTY?: number | null;
    ledgerCreditLY?: number | null;
    variance: number;
    variancePercent: number;
    reportCode: string;
    nature: NatureEnum;
    createdAt: string;
    updatedAt: string;
    canPostJournal: boolean;
    isTax?: boolean;
    worksheet?: { id: string; status: WorksheetStatusEnum } | null;
    entityAccountId: string | null;
};

export enum AccountClass {
    ASSET = 'ASSET',
    LIABILITY = 'LIABILITY',
    REVENUE = 'REVENUE',
    EXPENSE = 'EXPENSE',
    EQUITY = 'EQUITY',
}
